export const SCHEMA_NAME = "WarrantExtraditionInfo";

export const FIELDS = {
  EXTRADITION_AREA_ID: "extraditionAreaID",
  EXTRADITION_LIMITS: "extraditionLimits",
  REQUIRES_REVIEW: "requiresReview",
  REVIEW_COMMENTS: "reviewComments",
  REVIEW_DATE: "reviewDate",
  REVIEWED_BY_STAFF_ID: "reviewedByStaffID",
  WARRANT_EXTRADITION_INFO_ID: "warrantExtraditionInfoID",
  WARRANT_ID: "warrantID",
};
